// extracted by mini-css-extract-plugin
export var active = "_5z-b";
export var activeIndicator = "_5z-6";
export var animate = "_5z-a";
export var disabled = "_5z-c";
export var flat = "_5z-1";
export var fullWidth = "_5z-3";
export var lg = "_5z-9";
export var md = "_5z-8";
export var redoButtonTabGroup = "_5z-0";
export var sm = "_5z-7";
export var tabButton = "_5z-4";
export var tabButtonsContainer = "_5z-2";
export var xs = "_5z-5";